import React from "react";
import "./ResponseivePicture.scss";
import {assetFullPath} from "@commons/Utils";
import {BREAKPOINT, UIBreakpoints} from "@lib/Cms/CmsModels";

type ResponsivePictureProps = {
    images: string | string[];
    alt?: string;
    className?: string;
    loading?: "lazy" | "eager";
    cover?: boolean;
};

const ResponsivePicture: React.FC<ResponsivePictureProps> = ({
                                                                 images,
                                                                 alt = "",
                                                                 className,
                                                                 loading = "lazy",
                                                                 cover = false
                                                             }) => {
    if (images.length === 0) return null;

    const fallback = images[images.length - 1];

    const mobile = images[0];
    const tablet = images[1] ?? fallback;
    const desktop = images[2] ?? tablet;
    const wide = images[3] ?? desktop;
    const max = images[4] ?? wide;

    return (
        <picture className={`${className ?? ""} responsive-picture`}>
            {max && (
                <source
                    media={`(min-width: ${(UIBreakpoints[BREAKPOINT.MAX]) + 1}px)`}
                    srcSet={assetFullPath(max)}
                />
            )}
            {wide && (
                <source
                    media={`(min-width: ${(UIBreakpoints[BREAKPOINT.DESKTOP])}px)`}
                    srcSet={assetFullPath(wide)}
                />
            )}

            {desktop && (
                <source
                    media={`(min-width: ${(UIBreakpoints[BREAKPOINT.TABLET])}px)`}
                    srcSet={assetFullPath(desktop)}
                />
            )}

            {tablet && (
                <source
                    media={`(min-width: ${(UIBreakpoints[BREAKPOINT.MOBILE])}px)`}
                    srcSet={assetFullPath(tablet)}
                />
            )}

            <img
                src={assetFullPath(mobile)}
                alt={alt}
                loading={loading}
                className={`${cover ? "cover" : ""}`}
            />
        </picture>
    );
};

export default ResponsivePicture;